import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import { alertActions } from "../../alert.action";
import { elementService } from "../../../../services/cms/form/element/element.service";
import { deepClone } from "../../../../helpers/objectHelper";
import { formConstants } from "../../../../constants/cms/form/form.constants";

export const elementActions = {
  getAll,
  update,
  create,
  updateList,
  addToList, softUpdate
};

function getAll(eventId) {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());
    elementService.getAll(eventId).then(
      elements => dispatch(success(elements)),
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: elementConstants.GETALL_ELEMENTS_REQUEST };
  }
  function success(elements) {
    return { type: elementConstants.GETALL_ELEMENTS_SUCCESS, elements };
  }
  function failure(error) {
    return { type: elementConstants.GETALL_ELEMENTS_FAILURE, error };
  }
}

function softUpdate(element) {

  return dispatch => {
    dispatch(alertActions.clear());
    let newEl = deepClone(element);
    newEl.data = JSON.stringify(element.data);
    elementService.update(newEl).then(
      el => {
      },
      error => {
      }
    );
  };


  function success(element) {
    return { type: elementConstants.UPDATE_ELEMENT_SUCCESS, element };
  }

}

function update(element, updateToForm = false) {

  return dispatch => {
    dispatch(request(element.contentId));
    dispatch(alertActions.clear());
    let newEl = deepClone(element);
    newEl.data = JSON.stringify(element.data);
    elementService.update(newEl).then(
      el => {
        if(updateToForm){
          el.data = JSON.parse(el.data);
          dispatch(success({ ...el, contentId: element.contentId }));
        }
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(id) {
    return { type: elementConstants.UPDATE_ELEMENT_REQUEST, id };
  }
  function success(element) {
    return { type: formConstants.UPDATE_FORM_ELEMENT, element };
  }
  function failure(error) {
    return { type: elementConstants.UPDATE_ELEMENT_FAILURE, error };
  }
}
function addToList(element) {
  return dispatch => {
    dispatch(success(element));
  };

  function success(element) {
    return { type: elementConstants.ADD_TO_LIST_SUCCESS, element };
  }
}

function updateList(elements) {
  return dispatch => {
    dispatch(success(elements));
  };

  function success(elements) {
    return { type: elementConstants.UPDATE_LIST_SUCCESS, elements };
  }
}
function create(element) {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());
    element.data = JSON.stringify(element.data);
  /*   element.props = JSON.stringify(element.props); */
    elementService.create(element).then(
      element => {
        dispatch(success(element));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: elementConstants.CREATE_ELEMENT_REQUEST };
  }
  function success(element) {
    return { type: elementConstants.ADD_TO_LIST_SUCCESS, element };
  }
  function failure(error) {
    return { type: elementConstants.CREATE_ELEMENT_FAILURE, error };
  }
}
